import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { usersApi } from "@/lib/api";
import { FullPageSpinner } from "@/components/ui/spinner";

export default function ConfirmEmailChange() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const token = searchParams.get("token");
    if (!token) {
      toast.error("Confirmation link is invalid");
      navigate("/app/settings", { replace: true });
      return;
    }

    usersApi
      .confirmEmailChange(token)
      .then(({ email }) => {
        toast.success(`Email updated to ${email}`);
        navigate("/app/settings", { replace: true });
      })
      .catch(() => {
        toast.error("Confirmation link has expired — request the change again");
        navigate("/app/settings", { replace: true });
      });
  }, [searchParams, navigate]);

  return <FullPageSpinner label="Confirming your new email…" />;
}
